const AGENT_BASE = window._env_?.REACT_APP_TEMPLATE_AGENT_URL || 'http://localhost:8001';

export const modelBuilderApi = {
  streamChat: (body, signal) =>
    fetch(`${AGENT_BASE}/chat/model-builder`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
      body: JSON.stringify(body),
      signal,
    }),

  getThread: (threadId) =>
    fetch(`${AGENT_BASE}/threads/${threadId}?user_id=admin`).then(r => r.json()),

  getThreads: () =>
    fetch(`${AGENT_BASE}/threads?user_id=admin&agent=model-builder`).then(r => r.json()),

  getModels: () =>
    fetch(`${AGENT_BASE}/models`).then(r => r.json()),

  getSkills: () =>
    fetch(`${AGENT_BASE}/skills`).then(r => r.json()),

  getPreviewUrl: (fileId) => `${AGENT_BASE}/models/${fileId}/preview`,

  getDownloadUrl: (fileId) => `${AGENT_BASE}/models/${fileId}/download`,
};
